<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" md="8" class="px-10">
                    <h1 class="text-center mb-5">The Difference Automation Makes</h1>
                    <v-simple-table class="comparison">
                        <thead>
                            <tr>
                                <th class="text-center text-body-1 font-weight-semibold">Without Workflows</th>
                                <th class="text-center text-body-1 font-weight-semibold">With Workflows</th>
                            </tr>
                        </thead>
                    
                        <tbody>
                            <tr v-for="item in comparisons" :key="item.with">
                                <td class="pr-5 text-left"><v-icon color="grey" class="mr-2">mdi-alpha-x-circle</v-icon>{{ item.without }}</td>
                                <td class="pr-5 text-left"><v-icon color="primary" class="mr-2">mdi-check-circle</v-icon>{{ item.with }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsComparison',
    data: () => ({
        comparisons: [
            {
                with: 'Automatic, consistent follow-ups',
                without: 'Time-consuming manual follow-ups',
            },
            {
                with: 'Smooth customer journeys',
                without: 'Inconsistent customer experience',
            },
            {
                with: 'Teams focus on high-value work',
                without: 'Repetitive admin tasks',
            },
            {
                with: 'Reliable, scalable processes',
                without: 'Missed reminders and opportunities',
            },
            {
                with: 'No-code automations',
                without: 'Complicated programming for automation',
            },
            {
                with: 'Flexible Scheduler: daily, monthly, or on-demand',
                without: 'Manual, error-prone scheduling',
            },
            {
                with: 'Data & Reporting: automatic data pull and export',
                without: 'Reports done by hand'
            }
        ]
        }
    )
}

</script>

<style lang="scss">

hr {
    margin: 1em 0;
    width: 50%;
}
.comparison {
    table-layout: fixed; 
    width: 100%;
    thead {
        th {
            width: 50%;
        }
    }
    tbody {
        td {
            width: 50%;
        }
    }

}
</style>